<div class="flex flex-col">
  <app-header class="z-[100]"></app-header>
  <div class="w-full min-h-[92vh] bg-surface-20" id="container">
    <router-outlet (activate)="currentComp($event)"></router-outlet>
  </div>
</div>